<template>
  <div v-if="onsale != ''" class="bunjoinfo-list">
    <h4><slot name="locatename"></slot></h4>
    <table class="bunjo-list-table">
      <tr
        v-for="(product, index) in onsale"
        :key="index"
        v-bind:class="{ sold: product.status == '0' }"
      >
        <td class="name">{{ product.name }}</td>
        <td>
          <div class="label">
            <p class="cat">{{ product.category }}</p>
            <p class="status sale" v-if="product.status == 1">販売中</p>
            <p class="status sold" v-else-if="product.status == 0">売約済</p>
            <p class="status const" v-else-if="product.status == 2">建設中</p>
          </div>
        </td>

        <td class="tochi">
          <span>土地&nbsp;{{ product.tochi }}坪／</span>
          <span>建物&nbsp;{{ product.tatemono }}坪</span>
        </td>
        <td class="price">
          <templete v-if="product.status == 0">--</templete>
          <templete v-else-if="product.price == ''">お問い合わせ</templete>
          <templete v-else>{{ product.price }}万円</templete>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  props: ["listtarget"],
  data() {
    return {};
  },
  computed: {
    onsale() {
      const obj = this.$alllist[this.listtarget];
      let nowonsale = Object.values(obj).filter(function (list) {
        return list.status == "1" || list.status == "2";
      });
      return nowonsale;
    },
  },
};
</script>

<style lang="scss" scoped>
.bunjoinfo-list {
  width: 100%;
  margin: 0 auto;
  h4 {
    margin-top: 2rem;
    margin-bottom: 1rem;
    font-size: 1rem;
    font-weight: bold;
    color: $fontcolor_sub;
  }

  .bunjo-list-table {
    width: 100%;
    border-top: 1px solid $color_line;
    tr {
      width: 100%;
      font-size: 1rem;
      border-bottom: 1px solid $color_line;
      &.sold {
        background-color: $color_lgray;
        color: $fontcolor_sub;
      }
      td {
        line-height: 1.25;
        padding: 0.75em 0.5em;
        vertical-align: middle;
      }
      .name {
        font-weight: normal;
      }
      .label {
        flex-shrink: 0;
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        font-size: 0.8rem;
        width: 110px;
        overflow: hidden;
        @include sp {
          grid-template-columns: 1fr;
          width: 55px;
        }
        .cat,
        .status {
          text-align: center;
          padding: 0.25em 0.5em;
        }
        .cat {
          border: 1px solid $color_line;
          border-right: none;
          border-radius: 0.25em 0 0 0.25em;
          @include sp {
            border: 1px solid $color_line;
            border-bottom: none;
            border-radius: 0.25em 0.25em 0 0;
          }
        }
        .status {
          color: white;
          border-radius: 0 0.25em 0.25em 0;
          @include sp {
            border-radius: 0 0 0.25em 0.25em;
          }
          &.sold {
            background-color: $color_gray;
          }
          &.sale {
            background-color: $color_red;
          }
          &.const {
            background-color: $color_blue;
          }
        }
      }
      .tochi {
        font-size: 0.8rem;
        min-width: 7.5em;

        span {
          display: inline-block;
          @include tb {
            display: block;
          }
        }
      }

      .price {
        font-weight: bold;
        flex-shrink: 0;
        text-align: right;
      }
    }
  }
}
</style>
